import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import isValidMailFolderId from './isValidMailFolderId';
import { getDefaultFolderToLoad } from 'mini-mail-folder-store/lib/utils/getDefaultFolderToLoad';

export const getValidFolderNameOrIdWithFallback = (folderNameOrId: string): string => {
    const folderId = folderNameToId(folderNameOrId) || folderNameOrId;
    return isValidMailFolderId(folderId) ? folderNameOrId : getDefaultFolderToLoad();
};
